<template>
  <div>
    <div>
      <photos :photos="actif" @clicked="clic"></photos>
      <overlay :show="show" :image="imgsel" :titre="titre" :serie="serie" :total="total" @closed="close"></overlay>
    </div>
  </div>
</template>

<script>

import photos   from './photos.vue'
import overlay  from './overlay.vue'

export default {
  components: { photos, overlay },

  props: {
    page: String
  },

  watch: {
    page: function() {
      this.actif = this.liste[this.page]
    }
  },

  mounted() {
    this.liste['portraits']  = this.portrait
    this.liste['islands']    = this.landscape
    this.liste['travel']     = this.travel
    this.liste['japan']      = this.japan
    this.liste['steel']      = this.steel
    this.liste['desertcity'] = this.dubai

    this.actif = this.liste[this.page]
  },

  methods: {
    clic(p) {
      this.imgsel = p.id
      this.titre = p.txt
      this.serie = p.serie
      this.total = p.total
      this.show = true
    },

    close() {
      this.show = false
    },
  },

  data () {
    return {
      actif: null,
      show: false,
      imgsel: null,
      titre: null,
      serie: null,
      total: null,
      liste: Array,

      portrait: [
        { id: 'H1A2167.jpg', layout: 'half', img: 'square', txt: 'Alice 2018' },
        { id: 'H1A0170.jpg', layout: 'half', img: 'square', txt: 'Maxime 2017' },

        { id: '_MG_8145.jpg', layout: 'full', img: 'horizontal', txt: 'Juliette 2013' },
        { id: 'H1A1649.jpg', layout: 'full', img: 'horizontal', txt: '' },

        { id: 'H1A4031.jpg', layout: 'half', img: 'vertical', txt: 'Chloé 2016' },
        { id: '_MG_6683-Modifier.jpg', layout: 'half', img: 'vertical', txt: 'Paris 2013' },

        { id: 'IMG_0135-Modifier.jpg', layout: 'full', img: 'horizontal', txt: 'Barriol shipyards, Arles 2013' },

        { id: 'H1A2143.jpg', layout: 'half', img: 'square', txt: 'Brit 2018' },
        { id: '_MG_7518.jpg', layout: 'half', img: 'square', txt: 'Juliette 2013' },

        { id: '1805.jpg', layout: 'full', img: 'horizontal', txt: 'Chloé 2013' },
        { id: 'MH1A8337.jpg', layout: 'full', img: 'horizontal', txt: '2014' },

        { id: 'H1A5129.jpg', layout: 'half', img: 'square', txt: 'Céline 2018' },
        { id: '_H1A3642-Edit.jpg', layout: 'half', img: 'square', txt: 'Charlotte 2016' },

        { id: '_H1A3921-Modifier-Edit-Edit-Edit-4-Edit-2.jpg', layout: 'half', img: 'vertical', txt: 'Arles 2014' },
        { id: '_H1A4681.jpg', layout: 'half', img: 'vertical', txt: 'Arles 2014' },
      ],

      landscape: [
        { id: 'H1A5559.jpg', layout: 'full', img: 'horizontal', txt: 'São Vicente island, Cape Verde 2016' },
        { id: 'H1A7521.jpg', layout: 'full', img: 'horizontal', txt: 'Santo Antão island, Cape Verde 2016' },
        { id: 'IMG_2651.jpg', layout: 'full', img: 'horizontal', txt: 'Iceland 2007' },
        { id: 'IMG_3618-Edit.jpg', layout: 'full', img: 'horizontal', txt: 'Iceland 2007' },
        { id: 'IMG_2454.jpg', layout: 'full', img: 'horizontal', txt: 'Faroe islands 2012' },
        { id: 'IMG_2674.jpg', layout: 'full', img: 'horizontal', txt: 'Faroe islands 2012' },
        { id: 'IMG_4270-Edit.jpg', layout: 'full', img: 'horizontal', txt: 'Lofoten islands, Norway 2008' },
        { id: 'IMG_3095.jpg', layout: 'full', img: 'horizontal', txt: 'Lofoten islands, Norway 2008' },
        { id: 'IMG_3996-Edit.jpg', layout: 'full', img: 'horizontal', txt: 'Scotland 2012' },
        { id: '_MG_3822-Edit.jpg', layout: 'full', img: 'horizontal', txt: 'Risør, Norway 2013' },
        { id: 'IMG_0082.jpg', layout: 'full', img: 'horizontal', txt: 'Oia, Santorini island, Greece 2010' },


      ],

      travel: [
        { id: 'IMG_8914.jpg', layout: 'full', img: 'horizontal', txt: 'Taj Mahal, Agra, India 2008' },
        { id: 'IMG_0516-Edit.jpg', layout: 'full', img: 'horizontal', txt: 'San Giorgio Maggiore, Venezia, Italia 2009' },
/*        { id: 'IMG_0717.jpg', layout: 'full', img: 'horizontal', txt: '' }, */
        { id: 'IMG_8308.jpg', layout: 'full', img: 'horizontal', txt: 'Brooklyn Bridge, New York 2010' },
        { id: 'IMG_8535-Edit-3.jpg', layout: 'full', img: 'horizontal', txt: 'Brooklyn, New York 2010' },
        { id: 'IMG_8589.jpg', layout: 'full', img: 'horizontal', txt: 'New York 2010' },

      ],


      japan: [
        { id: 'DSC04120.jpg', layout: 'half', img: 'square' },
        { id: 'DSC09538.jpg', layout: 'half', img: 'square' },

        { id: 'DSC04656.jpg', layout: 'half', img: 'vertical' },
        { id: 'DSC07435.jpg', layout: 'half', img: 'vertical' },

        { id: 'DSC05668.jpg', layout: 'full', img: 'horizontal' },
        { id: 'DSC03020.jpg', layout: 'full', img: 'horizontal' },
        { id: 'DSC03196.jpg', layout: 'full', img: 'horizontal' },
        { id: 'DSC07823.jpg', layout: 'full', img: 'horizontal' },

        { id: 'DSC08963.jpg', layout: 'full', img: 'horizontal' },

      ],

      steel: [
        { id: 'metal/IMG_0162.jpg', layout: 'full', img: 'horizontal', txt: 'Barriol shipyards, Arles 2013', serie: 1, total: 18 },

        { id: 'metal/IMG_9770.jpg', layout: 'half', img: 'vertical', txt: 'Barriol shipyards, Arles 2013', serie: 2, total: 18 },
        { id: 'metal/IMG_9825.jpg', layout: 'half', img: 'horizontal', txt: 'Barriol shipyards, Arles 2013', serie: 3, total: 18 },
        { id: 'metal/IMG_9777.jpg', layout: 'half', img: 'horizontal', txt: 'Barriol shipyards, Arles 2013', serie: 4, total: 18 },
        { id: 'metal/IMG_9879.jpg', layout: 'half', img: 'horizontal', txt: 'Barriol shipyards, Arles 2013', serie: 5, total: 18 },

        { id: 'metal/IMG_0041.jpg', layout: 'half', img: 'square', txt: 'Barriol shipyards, Arles 2013', serie: 6, total: 18 },
        { id: 'metal/IMG_0002.jpg', layout: 'half', img: 'square', txt: 'Barriol shipyards, Arles 2013', serie: 7, total: 18 },
        { id: 'metal/IMG_0049.jpg', layout: 'half', img: 'square', txt: 'Barriol shipyards, Arles 2013', serie: 8, total: 18 },
        { id: 'metal/IMG_0015.jpg', layout: 'half', img: 'square', txt: 'Barriol shipyards, Arles 2013', serie: 9, total: 18 },

        { id: 'metal/IMG_0129.jpg', layout: 'full', img: 'horizontal', txt: 'Barriol shipyards, Arles 2013', serie: 10, total: 18 },

        { id: 'metal/IMG_9858.jpg', layout: 'half', img: 'vertical', txt: 'Barriol shipyards, Arles 2013', serie: 11, total: 18 },
        { id: 'metal/IMG_9913.jpg', layout: 'half', img: 'horizontal', txt: 'Barriol shipyards, Arles 2013', serie: 12, total: 18 },
        { id: 'metal/IMG_9925.jpg', layout: 'half', img: 'horizontal', txt: 'Barriol shipyards, Arles 2013', serie: 13, total: 18 },
        { id: 'metal/IMG_9942.jpg', layout: 'half', img: 'horizontal', txt: 'Barriol shipyards, Arles 2013', serie: 14, total: 18 },

        { id: 'metal/IMG_9911.jpg', layout: 'full', img: 'horizontal', txt: 'Barriol shipyards, Arles 2013', serie: 15, total: 18 },
        { id: 'metal/IMG_0068-Edit-4.jpg', layout: 'half', img: 'square', txt: 'Barriol shipyards, Arles 2013', serie: 16, total: 18 },
        { id: 'metal/IMG_0215.jpg', layout: 'half', img: 'square', txt: 'Barriol shipyards, Arles 2013', serie: 17, total: 18 },

        { id: 'metal/IMG_0135-Modifier-2.jpg', layout: 'full', img: 'horizontal', txt: 'Barriol shipyards, Arles 2013', serie: 18, total: 18 }
      ],

      dubai: [
        { id: 'dubai/DSC01298 1.jpg', layout: 'full', img: 'horizontal' },
        { id: 'dubai/DSC01356.jpg', layout: 'half', img: 'square' },
        { id: 'dubai/DSC01328.jpg', layout: 'half', img: 'square' },
        { id: 'dubai/DSC01381.jpg', layout: 'full', img: 'horizontal' },
        { id: 'dubai/DSC01359 1.jpg', layout: 'full', img: 'horizontal' },
        { id: 'dubai/DSC01396.jpg', layout: 'full', img: 'horizontal' },
        { id: 'dubai/DSC01453.jpg', layout: 'full', img: 'horizontal' },
        { id: 'dubai/DSC01416.jpg', layout: 'half', img: 'square' },
        { id: 'dubai/DSC01405.jpg', layout: 'half', img: 'square' },
        { id: 'dubai/DSC01468 1.jpg', layout: 'full', img: 'horizontal' },
        { id: 'dubai/DSC01492.jpg', layout: 'full', img: 'horizontal' },
        { id: 'dubai/DSC01588.jpg', layout: 'full', img: 'horizontal' }
      ]

    }
  }

}

</script>
